import { Language, LanguageEnum } from '../models'
import en from './en.json'
import vi from './vi.json'

export const translate = (key: string, language: string): string => {
  let languageData: { [key: string]: string } = {}

  switch (language) {
    case LanguageEnum.EN:
      languageData = en
      break
    case LanguageEnum.VI:
      languageData = vi
      break
    default:
      languageData = vi
      break
  }
  return languageData[key]
}

export const languages: Language[] = [
  {
    prefix: LanguageEnum.EN,
    value: 'English',
  },
  {
    prefix: LanguageEnum.VI,
    value: 'Tiếng Việt',
  },
]
